<template>
  <v-container style="max-width: 1800px !important">
    <div class="pa-3 ma-3">
      <v-alert-dialog ref="alert"> </v-alert-dialog>

      <!-- DETALLES -->
      <v-dialog v-model="dialogView" max-width="80%" persistent>
        <v-card>
          <v-card-title>Detalles del Empleado</v-card-title>
          <v-card-text v-if="loadingDetails" class="text-center py-8">
            <v-progress-circular
              indeterminate
              size="128"
              width="4"
              class="mb-3"
              color="primary"
            ></v-progress-circular>
            <div class="text-subtitle-2">
              Cargando detalles del empleado ...
            </div>
          </v-card-text>
          <v-card-text v-else>
            <v-row class="pa-0 ma-0">
              <v-col cols="12" class="pa-0 ma-0 text-center">
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>mdi-account</v-icon>
                  Datos Personales
                </div>
              </v-col>

              <!-- DATOS PERSONALES -->
              <v-col cols="3">
                <div class="text-subtitle-2">Nombre:</div>
                <div>{{ viewedItem.nombre }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Apellido paterno:</div>
                <div>{{ viewedItem.apellido_paterno }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Apellido materno:</div>
                <div>{{ viewedItem.apellido_materno }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Fecha de nacimiento:</div>
                <div>{{ viewedItem.fecha_nacimiento_beauty || viewedItem.fecha_nacimiento }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Género:</div>
                <div>{{ viewedItem.genero == 0 ? 'Femenino' : 'Masculino' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Estado civil:</div>
                <div>{{ viewedItem.nombre_estado_civil || 'N/D' }}</div>
              </v-col>

              <!-- IDENTIFICACIONES -->
              <v-col cols="3">
                <div class="text-subtitle-2">CURP:</div>
                <div>{{ viewedItem.curp_valor }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">RFC:</div>
                <div>{{ viewedItem.rfc_valor }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Número de Seguridad Social:</div>
                <div>{{ viewedItem.nss_valor || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">No. trabajador (NOI):</div>
                <div>{{ viewedItem.noi_numero_trabajador || 'N/D' }}</div>
              </v-col>

              <v-col cols="6">
              </v-col>

              <v-col
                cols="12"
                class="pb-0 mb-0 text-center"
              >
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-phone
                  </v-icon>
                  Datos de Contacto
                </div>
              </v-col>

              <!-- CONTACTO -->
              <v-col cols="6">
                <div class="text-subtitle-2">Dirección:</div>
                <div>{{ viewedItem.direccion || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2"># Exterior:</div>
                <div>{{ viewedItem.num_exterior || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2"># Interior:</div>
                <div>{{ viewedItem.num_interior || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Colonia:</div>
                <div>{{ viewedItem.colonia || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Código postal:</div>
                <div>{{ viewedItem.cp || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Estado:</div>
                <div>{{ viewedItem.nombre_estado || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Município:</div>
                <div>{{ viewedItem.nombre_municipio || 'N/D' }}</div>
              </v-col>

              <v-col cols="6">
                <div class="text-subtitle-2">Teléfono de contacto:</div>
                <div>{{ viewedItem.telefono || 'N/D' }}</div>
              </v-col>

              <v-col cols="6">
                <div class="text-subtitle-2">Email de contacto:</div>
                <div>{{ viewedItem.email || 'N/D' }}</div>
              </v-col>

              <v-col cols="6">
                <div class="text-subtitle-2">Nombre completo del contacto de emergencia:</div>
                <div>{{ viewedItem.nombre_contacto_emergencia || 'N/D' }}</div>
              </v-col>

              <v-col cols="6">
                <div class="text-subtitle-2">Número de celular del contacto de emergencia:</div>
                <div>{{ viewedItem.telefono_contacto_emergencia || 'N/D' }}</div>
              </v-col>

              <!-- INFORMACIÓN LABORAL -->
              <v-col
                cols="12"
                class="pb-0 mb-0 text-center"
              >
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-briefcase
                  </v-icon>
                  Información Laboral
                </div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">Puesto:</div>
                <div>{{ viewedItem.nombre_puesto }}</div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">Fecha de alta:</div>
                <div>{{ viewedItem.fecha_alta }}</div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">Sueldo quincenal bruto:</div>
                <div>{{ viewedItem.sueldo_bruto_quincenal != null ? formatMoney(viewedItem.sueldo_bruto_quincenal) : 'N/D' }}</div>
              </v-col>

              <!-- INFORMACIÓN LEGAL/FISCAL -->
              <v-col
                cols="12"
                class="pb-0 mb-0 text-center"
              >
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-scale-balance
                  </v-icon>
                  Información Legal/Fiscal
                </div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">¿Tiene activo el régimen de sueldos y salarios e ingresos asimilados a salarios?:</div>
                <div>{{ (viewedItem.regimen_sueldos != null) ? (viewedItem.regimen_sueldos ? 'Sí' : 'No') : 'N/D' }}</div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">¿Tiene algún crédito u obligación legal que afecte su nómina?:</div>
                <div>{{ (viewedItem.tiene_credito != null) ? (viewedItem.tiene_credito ? 'Sí' : 'No') : 'N/D' }}</div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">Tipo de crédito u obligación legal:</div>
                <div>{{ (viewedItem.nombres_tipo_credito != null && viewedItem.nombres_tipo_credito.length > 0) ? (viewedItem.nombres_tipo_credito || []).join(', ') : 'N/A' }}</div>
              </v-col>

              <v-col cols="12">
                <v-simple-table dense class="mb-2">
                  <thead>
                    <tr>
                      <th class="text-left" style="width: 33.33%">Nombre completo del beneficiario</th>
                      <th class="text-left" style="width: 33.33%">Número de celular del beneficiario</th>
                      <th class="text-left" style="width: 33.33%">Parentesco del beneficiario</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in viewedItem.beneficiarios" :key="'beneficiario-' + i">
                      <td>
                        {{ row.nombre_completo }}
                      </td>
                      <td>
                        {{ row.telefono }}
                      </td>
                      <td>
                        {{ row.nombre_parentesco }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>

              <v-col
                v-if="viewedItem.requisitos != null && viewedItem.requisitos.length > 0"
                cols="12"
                class="pa-0 ma-0 text-center"
              >
                <br>
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-file-document-outline
                  </v-icon>
                  Documentación
                </div>
              </v-col>

              <template
                v-for="expediente_requisito in viewedItem.requisitos"
              >
                <v-col
                  :key="expediente_requisito.codigo"
                  cols="6"
                >
                  <div
                    v-if="expediente_requisito.observacion != null"
                    class="red--text text-caption"
                  >
                    Motivo de Rechazo: {{expediente_requisito.observacion}}
                  </div>

                  <template v-if="expediente_requisito.tipo_documento == 1">
                    <v-viewer
                      v-if="expediente_requisito.documento != null"
                      v-model="expediente_requisito.documento"
                      urlBase="/api/RecursosHumanos/DescargarDocumento"
                      :label="`${expediente_requisito.nombre}`"
                    ></v-viewer>

                    <div v-else>
                      <div class="text-subtitle-2">{{expediente_requisito.nombre}}:</div>
                      <div>Documento no Proporcionado</div>
                    </div>

                    <div v-if="expediente_requisito.nota != null" class="text-caption note-style">
                      Nota: {{expediente_requisito.nota}}
                    </div>
                  </template>

                  <template v-else>
                    <div class="text-subtitle-2">{{expediente_requisito.nombre}}:</div>
                    <div>{{ expediente_requisito.documento || 'N/D' }}</div>
                    <div v-if="expediente_requisito.nota != null" class="text-caption note-style">
                      Nota: {{expediente_requisito.nota}}
                    </div>
                  </template>
                </v-col>
              </template>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" text @click="closeDialogView">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <!-- GENERACION MASIVA -->
    <v-dialog
      v-model="dialogGeneracionMasiva"
      persistent
      max-width="80%"
    >
      <v-card elevation="0">
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Generación Masiva de Contratos</span>
          <v-btn v-if="procesoGeneracionMasiva <= 1" icon @click="close">
            <v-icon x-large>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-stepper v-model="procesoGeneracionMasiva">
            <v-stepper-header>
              <v-stepper-step :complete="procesoGeneracionMasiva > 1" step="1">
                Información Adicional
                <small class="d-block">Ingrese los datos requeridos</small>
              </v-stepper-step>

              <v-divider />

              <v-stepper-step :complete="procesoGeneracionMasiva > 2" step="2">
                Generando Contratos
              </v-stepper-step>

              <v-divider />

              <v-stepper-step step="3">
                Descarga de Contratos
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>

              <!-- PASO 1 -->
              <v-stepper-content step="1">
                <v-alert type="info" dense outlined class="mb-4">
                  Antes de continuar, necesitamos completar la información faltante para generar los contratos de los empleados seleccionados.
                </v-alert>

                <v-row>
                  <v-col cols="12">
                    <v-select
                      v-model="contratoMasivoItem.ciudad"
                      :items="lugaresFirma"
                      dense
                      hide-details
                      outlined
                      label="Lugar de Firma de Contrato"
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <br>

                <div class="d-flex ga-2">
                  <v-btn
                    color="primary"
                    @click="iniciarGeneracionMasiva"
                    outlined
                    dense
                    block
                    :loading="loadingGeneracionMasiva"
                  >
                    <v-icon>mdi-file-cog-outline</v-icon>
                    Iniciar Generación
                  </v-btn>
                </div>
              </v-stepper-content>

              <!-- PASO 2 -->
              <v-stepper-content step="2">
                <lottie :options="gearAnimation" :height="200" />
                <div class="text-center my-8">
                  <div class="display-1 font-weight-bold brown--text text--darken-2">
                    Generando Contratos…
                  </div>
                  <div class="subtitle-1 grey--text">
                    Por favor espera, estamos generando los contratos de los empleados seleccionados.
                  </div>
                </div>
              </v-stepper-content>

              <!-- PASO 3 -->
              <v-stepper-content step="3" class="text-center">
                <v-icon color="green" size="200">
                  mdi-check-circle
                </v-icon>

                <div class="text-center my-8">
                  <div class="display-1 font-weight-bold brown--text text--darken-2">
                    Contratos Generados Correctamente
                  </div>
                  <div class="subtitle-1 grey--text">
                    Todos los contratos fueron generados correctamente. Ya puedes descargarlos.
                  </div>
                </div>

                <div class="d-flex ga-2">
                  <v-btn
                    color="primary"
                    @click="descargarContratos"
                    outlined
                    dense
                    block
                  >
                    <v-icon>mdi-download</v-icon>
                    Descargar Contratos
                  </v-btn>
                </div>

                <div class="d-flex ga-2">
                  <v-spacer></v-spacer>
                  <v-btn text @click="close">Cerrar</v-btn>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>

    <cargar-contrato-dialog
      v-model="dialogUpload"
      :item="uploadItem"
      @uploaded="getItems"
    />

    <v-dialog
      v-model="dialogViewContract"
      persistent
      max-width="80%"
    >
      <v-card>
        <v-card-title>
          Visualizar Contrato
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <div class="text-subtitle-2">Nombre:</div>
              <div>{{ viewedItem.nombre }}</div>
            </v-col>

            <v-col cols="4">
              <div class="text-subtitle-2">Apellido paterno:</div>
              <div>{{ viewedItem.apellido_paterno }}</div>
            </v-col>

            <v-col cols="4">
              <div class="text-subtitle-2">Apellido materno:</div>
              <div>{{ viewedItem.apellido_materno }}</div>
            </v-col>

            <v-col cols="4">
              <div class="text-subtitle-2">Puesto:</div>
              <div>{{ viewedItem.nombre_puesto }}</div>
            </v-col>

            <v-col cols="4">
              <div class="text-subtitle-2">Periodo:</div>
              <div>{{ getTextPeriodo(viewedItem) }}</div>
            </v-col>

            <v-col cols="4">
              <div class="text-subtitle-2">Contrato cargado por:</div>
              <div>{{ viewedItem.nombre_usuario_contrato || '' }} {{viewedItem.fecha_contrato || ''}}</div>
            </v-col>

            <v-col cols="12">
              <v-viewer
                v-if="viewedItem.contrato_documento != null"
                v-model="viewedItem.contrato_documento"
                urlBase="/api/RecursosHumanos/DescargarContratoFirmado"
                :label="`Contrato`"
              ></v-viewer>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer>
          </v-spacer>
          <v-btn
            color="green"
            text
            @click="closeDialogFile"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-row>
        <v-col cols="12" md="6" class="d-flex">
          <v-card outlined class="pa-4 flex-grow-1">
            <div class="caption mb-1">Empleados Habilitados para Contrato</div>

            <div class="kpi-line">
              <span class="kpi-figure">{{ pct(stats.habilitados_per) }}</span>
              <span class="kpi-pill kpi-pill--success">
                {{ nf(stats.habilitados_num) }} /
                {{ nf(stats.total) }}
              </span>
            </div>

            <v-progress-linear :value="stats.habilitados_per * 100" height="8" color="primary" class="mt-2" />
          </v-card>
        </v-col>

        <v-col cols="12" md="6" class="d-flex">
          <v-card outlined class="pa-4 flex-grow-1 d-flex align-center">
            <v-list-item class="pa-0">
              <v-list-item-avatar size="48" color="orange lighten-5" class="mr-3">
                <v-icon size="28" color="orange darken-2">
                  mdi-file-document-alert-outline
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <div class="text-body-2 grey--text text--darken-2 mb-1">
                  Número de contratos pendientes de carga
                </div>
                <div class="d-flex align-center">
                  <span class="text-h5 font-weight-bold mr-3">
                    {{ nf(stats.habilitados_num) }}
                  </span>
                  <v-chip x-small outlined color="orange darken-2">
                    Pendientes
                  </v-chip>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model.lazy="search.codigoEmpleado"
            label="Código de empleado"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="3">
          <v-text-field
            v-model.lazy="search.nombre"
            label="Nombre"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>
        
        <v-col cols="3">
          <v-text-field
            v-model.lazy="search.apellidoPaterno"
            label="Apellido Paterno"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="3">
          <v-text-field
            v-model.lazy="search.apellidoMaterno"
            label="Apellido Materno"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="3">
          <v-text-field
            v-model.lazy="search.rfc"
            label="RFC"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="3">
          <v-autocomplete
            v-model="search.tipoPuestos"
            :items="areaPuestos"
            item-value="id_rh_area"
            item-text="nombre"
            label="Tipos de Puestos"
            outlined
            dense
            hide-details
            multiple
            chips
            deletable-chips
            clearable
            @change="changeTipoPuestos"
          />
        </v-col>

        <v-col cols="3">
          <v-autocomplete
            v-model="search.puestos"
            label="Puestos"
            clearable
            :items="puestosFiltrados"
            item-value="id_puesto"
            item-text="nombre"
            dense
            hide-details
            outlined
            multiple
            chips
            deletable-chips
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="3">
          <v-btn
            block
            color="primary"
            text
            outlined
            @click="getItems"
            :disabled="loading"
            :loading="loading"
          >
            <v-icon>
              mdi-magnify
            </v-icon>
            Buscar
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-data-table
            v-model="selected"
            :loading="loading"
            :headers="headers"
            :items="items"
            show-select
            checkbox-color="primary"
            item-key="id_empleado_puesto"
             @toggle-select-all="onToggleSelectAll"
          >
            <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
              <v-simple-checkbox
                :value="isSelected"
                :disabled="!item.empleado_perfil_completo"
                @input="select"
              />
            </template>
            <template v-slot:[`item.periodo`]="{ item }">
              {{ getTextPeriodo(item) }}
            </template>
            <template v-slot:[`item.nombre_tipo_contrato`]="{ item }">
              <div class="d-inline-flex align-center">
                <v-tooltip
                  color="black"
                  bottom
                  v-if="item.fecha_asigno_tipo_contrato || item.nombre_usuario_asigno_tipo_contrato"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ item.nombre_tipo_contrato || "Por Definir" }}
                    </span>
                  </template>
                  <span>
                    Asignado por: {{ item.nombre_usuario_asigno_tipo_contrato || "-" }}<br>
                    Fecha de asignación: {{ item.fecha_asigno_tipo_contrato || "-" }}
                  </span>
                </v-tooltip>
                <span v-else>{{ item.nombre_tipo_contrato || "Por Definir" }}</span>
              </div>
            </template>
            <template v-slot:[`item.empleado_perfil_completo`]="{ item }">
              <v-tooltip bottom v-if="!item.empleado_perfil_completo" color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="red"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-close-circle
                  </v-icon>
                </template>

                <span>
                  <ul style="list-style-type: disc; padding-left: 16px;">
                    <li v-for="(err, index) in item.errores_empleado_perfil" :key="index">
                      {{ err }}
                    </li>
                  </ul>
                </span>
              </v-tooltip>

              <v-icon
                v-else
                color="green"
              >
                mdi-check-circle
              </v-icon>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip v-if="item.id_empleado_puesto != null" bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="mr-2" small v-bind="attrs" v-on="on" @click="openDialogView(item)">
                    mdi-eye
                  </v-icon>
                </template>
                <span>Ver detalles</span>
              </v-tooltip>
              <template v-if="item.empleado_perfil_completo">
                <v-tooltip v-if="item.contrato_documento == null" bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="mr-2" small v-bind="attrs" v-on="on" @click="openDialogUpload(item)">
                      mdi-upload
                    </v-icon>
                  </template>
                  <span>Cargar contrato firmado</span>
                </v-tooltip>
                <v-tooltip v-else bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="mr-2" small v-bind="attrs" v-on="on" @click="openDialogFile(item)">
                      mdi-file-document
                    </v-icon>
                  </template>
                  <span>Visualizar contrato firmado</span>
                </v-tooltip>
              </template>
            </template>
          </v-data-table>
        </v-col>

        <v-col cols="12">
          <v-btn
            color="primary"
            block
            class="white--text"
            :disabled="!anySelected"
            @click="openDialogGeneracionMasiva"
          >
            <v-icon>mdi-download</v-icon>
            Obtener Contratos Seleccionados
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import VAlertDialog from "@/components/VAlertDialog.vue";
import VViewer from '@/components/VViewer.vue';
import CargarContratoDialog from './CargarContratoDialog.vue';
import { mapState } from 'vuex';
import Lottie from 'vue-lottie';
import gearAnimationData from '@/assets/gear.json';

export default {
  components: {
    VAlertDialog,
    VViewer,
    CargarContratoDialog,
    'lottie': Lottie,
  },
  data: () => ({
    gearAnimation: { animationData: gearAnimationData, loop: true },
    dialogView: false,
    loading: false,
    items: [],
    headers: [
      { text: "Estado", value: "empleado_perfil_completo", align: "center" },
      { text: "# Empleado", value: "codigo_empleado", align: "center" },
      { text: "Nombre", value: "nombre", align: "center" },
      { text: "Apellido paterno", value: "apellido_paterno", align: "center" },
      { text: "Apellido materno", value: "apellido_materno", align: "center" },
      { text: "Puesto", value: "nombre_puesto", align: "center" },
      { text: "Periodo", value: "periodo", align: "center" },
      { text: "Tipo de Contrato", value: "nombre_tipo_contrato", align: "center" },
      { text: "RFC", value: "rfc_valor", align: "center" },
      { text: "Acciones", value: "actions", sortable: false, align: "center" },
    ],
    viewedItem: {
      id_empleado: null,
      codigo_empleado: null,
      nombre: null,
      apellido_paterno: null,
      apellido_materno: null,
      fecha_nacimiento: null,
      fecha_nacimiento_beauty: null,
      genero: 0,
      id_estado_civil: null,
      nombre_estado_civil: null,
      curp_valor: null,
      rfc_valor: null,
      nss_valor: null,
      noi_numero_trabajador: null,
      direccion: null,
      num_exterior: null,
      num_interior: null,
      colonia: null,
      cp: null,
      id_estado: null,
      nombre_estado: null,
      id_municipio: null,
      nombre_municipio: null,
      telefono: null,
      email: null,
      nombre_contacto_emergencia: null,
      telefono_contacto_emergencia: null,
      id_puesto: null,
      nombre_puesto: null,
      fecha_alta: null,
      sueldo_bruto_quincenal: null,
      regimen_sueldos: null,
      tiene_credito: null,
      ids_tipo_credito: null,
      nombres_tipo_credito: [],
      beneficiarios: [],
      pendiente_carga: true,
      expediente_validado: false,
      expediente_validado_fecha: null,
      expediente_validado_por: null,
      requisitos: [],
      sueldo_cargado: false,
      id_rh_area: null,
      fecha_desde: null,
      fecha_hasta: null,
      contrato_documento: null,
      id_usuario_contrato: null,
      nombre_usuario_contrato: null,
      fecha_contrato: null
    },
    defaultViewedItem: {
      id_empleado: null,
      codigo_empleado: null,
      nombre: null,
      apellido_paterno: null,
      apellido_materno: null,
      fecha_nacimiento: null,
      fecha_nacimiento_beauty: null,
      genero: 0,
      id_estado_civil: null,
      nombre_estado_civil: null,
      curp_valor: null,
      rfc_valor: null,
      nss_valor: null,
      noi_numero_trabajador: null,
      direccion: null,
      num_exterior: null,
      num_interior: null,
      colonia: null,
      cp: null,
      id_estado: null,
      nombre_estado: null,
      id_municipio: null,
      nombre_municipio: null,
      telefono: null,
      email: null,
      nombre_contacto_emergencia: null,
      telefono_contacto_emergencia: null,
      id_puesto: null,
      nombre_puesto: null,
      fecha_alta: null,
      sueldo_bruto_quincenal: null,
      regimen_sueldos: null,
      tiene_credito: null,
      ids_tipo_credito: null,
      nombres_tipo_credito: [],
      beneficiarios: [],
      pendiente_carga: true,
      expediente_validado: false,
      expediente_validado_fecha: null,
      expediente_validado_por: null,
      requisitos: [],
      sueldo_cargado: false,
      id_rh_area: null,
      fecha_desde: null,
      fecha_hasta: null,
      contrato_documento: null,
      id_usuario_contrato: null,
      nombre_usuario_contrato: null,
      fecha_contrato: null
    },
    stats: {
      habilitados_per: 0,
      habilitados_num: 0,
      total: 0,
    },
    defaultStats: {
      habilitados_per: 0,
      habilitados_num: 0,
      total: 0,
    },
    search: {
      codigoEmpleado: '',
      nombre: '',
      apellidoPaterno: '',
      apellidoMaterno: '',
      rfc: '',
      tipoPuestos:[],
      puestos: []
    },
    loadingDetails: false,
    selected: [],
    loadingAreaPuestos: false,
    areaPuestos: [],
    loadingPuestos: false,
    puestos: [],
    loadingGeneracionMasiva: false,
    intervalGeneracionMasiva: null,
    idJobGeneracionMasiva: null,
    dialogGeneracionMasiva: false,
    procesoGeneracionMasiva: 1,
    resultadoGeneracionMasiva: null,
    contratoMasivoItem: {
      ciudad: null
    },
    defaultContratoMasivoItem: {
      ciudad: null
    },
    lugaresFirma: ['Villahermosa, Tab.', 'Puebla, Pue.'],
    dialogUpload: false,
    uploadItem: null,
    dialogViewContract: false
  }),
  mounted() {
    this.getItems();
    this.getPuestos();
    this.getRHAreas();
    this.checkGeneracionMasivaPendiente();
  },
  methods: {
    getPuestos(){
      this.loadingPuestos = true;
      axios.get('/RecursosHumanos/ListarPuestos')
        .then(r => { this.puestos = r.data; })
        .catch(() => { /* noop */ })
        .finally(() => { this.loadingPuestos = false; })
    },
    getRHAreas() {
      this.loadingAreaPuestos = true;
      axios
        .get("/RHCatalogos/ListarRHAreas")
        .then((res) => {
          this.areaPuestos = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loadingAreaPuestos = false;
        });
    },
    getUrl(){
      const url = new URL(`http://localhost/RecursosHumanos/ListarEmpleadosContratos`);
      if(this.search.codigoEmpleado != null && this.search.codigoEmpleado.length > 0) url.searchParams.append("codigo_empleado", this.search.codigoEmpleado);
      if(this.search.nombre != null && this.search.nombre.length > 0) url.searchParams.append("nombre", this.search.nombre);
      if(this.search.apellidoPaterno != null && this.search.apellidoPaterno.length > 0) url.searchParams.append("apellido_paterno", this.search.apellidoPaterno);
      if(this.search.apellidoMaterno != null && this.search.apellidoMaterno.length > 0) url.searchParams.append("apellido_materno", this.search.apellidoMaterno);
      if(this.search.rfc != null && this.search.rfc.length > 0) url.searchParams.append("rfc", this.search.rfc);
      
      if(this.search.tipoPuestos != null && this.search.tipoPuestos.length > 0) {
        this.search.tipoPuestos.forEach(tp => {
          url.searchParams.append("ids_rh_areas", tp);
        })
      }
      
      if(this.search.puestos != null && this.search.puestos.length > 0) {
        this.search.puestos.forEach(p => {
          url.searchParams.append("ids_puestos", p);
        })
      }

      return url.href.replace('http://localhost', '');
    },
    getItems() {
      this.loading = true;
      
      this.stats = Object.assign({}, this.defaultStats);
      this.items = [];

      axios.get(this.getUrl())
        .then(r => {
          this.items = r.data;

          this.stats.total = r.data.length;
          const empleadosHabilitados = r.data.filter(x => x.empleado_perfil_completo === true);
          this.stats.habilitados_num = empleadosHabilitados.length;
          this.stats.habilitados_per = this.stats.total > 0 ? (this.stats.habilitados_num / this.stats.total) : 0;
        })
        .catch(() => {
          /* noop */
        })
        .finally(() => {
          this.loading = false;
        })
    },
    openDialogView(editItem) {
      this.dialogView = true;
      this.loadingDetails = true;
      axios
        .get(`/RecursosHumanos/DetalleEmpleadoPuesto/${editItem.id_empleado_puesto}`)
        .then(response => {
          this.viewedItem = response.data;
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loadingDetails = false;
        })
    },
    closeDialogView() {
      this.viewedItem = Object.assign({}, this.defaultViewedItem);
      this.dialogView = false;
    },
    formatMoney(number) {
      if (!number) return "";
      let numberString = number.toFixed(2);
      let formattedNumber = "$" + numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedNumber;
    },
    pct(v) {
      return `${(v * 100).toFixed(1)}%`
    },
    nf(n) {
      return new Intl.NumberFormat('es-MX').format(n || 0)
    },
    changeTipoPuestos(){
      this.puestosSearch = [];
    },
    onToggleSelectAll ({ value }) {
      console.log(value, this.selected)
      if (value && this.selected.length == 0) {
        // “Seleccionar todo”: solo los que tienen perfil completo
        this.selected = this.items.filter(x => x.empleado_perfil_completo);
      } else {
        // “Quitar todo”
        this.selected = [];
      }
    },
    getTextPeriodo(item){
      if(item.fecha_desde == 'Indefinido' && item.fecha_hasta == 'Indefinido') return ' - ';
      else return `${item.fecha_desde} - ${item.fecha_hasta}`;
    },
    nuevaPestana(url) {
      window.open(url, '_blank');
    },
    openDialogGeneracionMasiva(){
      this.dialogGeneracionMasiva = true;
    },
    close(){
      this.restablecerFlujoGeneracionMasiva();
      this.dialogGeneracionMasiva = false;
    },
    validateContratos(){
      if(this.contratoMasivoItem.ciudad == null || this.contratoMasivoItem.ciudad.length <= 0){
        this.$refs.alert.setMessage('', `Debe de indicar una ciudad`);
        this.$refs.alert.open();
        return false;
      }

      return true;
    },
    iniciarGeneracionMasiva(){
      if(!this.validateContratos()) return;

      this.loadingGeneracionMasiva = true;

      var empleados = this.selected.map(x => {
        return {
          id_empleado: x.id_empleado,
          id_empleado_puesto: x.id_empleado_puesto,
        }
      });

      axios
      .post('/RecursosHumanos/GenerarContratosLanzar', {
        ciudad: this.contratoMasivoItem.ciudad,
        empleados: empleados
      })
      .then(response => {
        this.idJobGeneracionMasiva = response.data;
        this.procesoGeneracionMasiva = 2;
        this.iniciarIntervaloGeneracionMasiva();
        this.selected = [];
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingGeneracionMasiva = false;
      })
    },
    iniciarIntervaloGeneracionMasiva(){
      if(this.intervalGeneracionMasiva == null){
        this.intervalGeneracionMasiva = setInterval(() => {
          this.actualizarGeneracionMasivaEstado();
        }, 2000);
      }
    },
    detenerIntervaloGeneracionMasiva(){
      if(this.intervalGeneracionMasiva != null){
        clearInterval(this.intervalGeneracionMasiva);
        this.intervalGeneracionMasiva = null;
      }
    },
    actualizarGeneracionMasivaEstado(){
      axios
      .get(`/RecursosHumanos/ContratoMasivoEstado/${this.idJobGeneracionMasiva}`)
      .then(response => {
        if(response.data.completado){
          this.detenerIntervaloGeneracionMasiva();
          this.procesoGeneracionMasiva = 3;
          this.resultadoGeneracionMasiva = response.data.resultado;
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    restablecerFlujoGeneracionMasiva(){
      this.procesoGeneracionMasiva = 1;
      this.idJobGeneracionMasiva = null;
      this.detenerIntervaloGeneracionMasiva();
      this.loadingGeneracionMasiva = false;
      this.resultadoGeneracionMasiva = null;
      this.contratoMasivoItem = Object.assign({}, this.defaultContratoMasivoItem);
      this.selected = [];
    },
    checkGeneracionMasivaPendiente(){
      axios
      .get('/RecursosHumanos/ContratoMasivosPendiente')
      .then(response => {
        console.log(response.data.ids_jobs)
        if(response.data.ids_jobs != null && response.data.ids_jobs.length > 0){
          this.dialogGeneracionMasiva = true;
          this.idJobGeneracionMasiva = response.data.ids_jobs[0];
          this.procesoGeneracionMasiva = 2;
          this.iniciarIntervaloGeneracionMasiva();
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    descargarContratos(){
      this.nuevaPestana(`/api/RecursosHumanos/DescargarContratos/${this.resultadoGeneracionMasiva}?jwt=${this.token}`)
    },
    openDialogUpload(item){
      this.uploadItem = Object.assign({}, item);
      this.dialogUpload = true;
    },
    openDialogFile(item){
      this.viewedItem = item;
      this.dialogViewContract = true;
    },
    closeDialogFile(){
      this.viewedItem = Object.assign({}, this.defaultViewedItem);
      this.dialogViewContract = false;
    },
  },
  computed: {
    ...mapState(['token']),
    puestosFiltrados(){
      if(!this.search.tipoPuestos || this.search.tipoPuestos.length <= 0) return this.puestos;

      return this.puestos.filter(p => this.search.tipoPuestos.includes(p.id_rh_area));
    },
    anySelected(){
      if (!Array.isArray(this.selected) || this.selected.length === 0) return false;
      return true;
    }
  }
};
</script>

<style scoped>
.kpi-line {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.kpi-figure {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1;
}

.kpi-pill {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.85rem;
  line-height: 1.2;
  border: 1px solid transparent;
}

.kpi-pill--success {
  background: #e8f5e9;   /* green lighten-5 */
  color: #2e7d32;        /* green darken-3 */
  border-color: #c8e6c9; /* green lighten-4 */
}

.kpi-pill--info {
  background: #e3f2fd;   /* blue lighten-5 */
  color: #1565c0;        /* blue darken-3 */
  border-color: #bbdefb; /* blue lighten-4 */
}

.kpi-pill--warning {
  background: #fff8e1;   /* amber lighten-5 */
  color: #ef6c00;        /* orange darken-3 */
  border-color: #ffe0b2; /* orange lighten-4 */
}
</style>
